import React, { FC, memo, useMemo } from 'react';
import { Box, Typography } from '@mui/material';
import CustomInput from '../../custom/CustomInput';
import CustomButton from '../../custom/CustomButton';
import { ReactComponent as SaveIcon } from '../../../assets/images/save.svg';
import SquaredIconButton from '../../custom/SquaredIconButton';
import { JstSubmission } from '../../../models/inputTypes/JstFields';
import LabelWrapper from '../../common/LabelWrapper';

const styles = {
  spacingContainer: {
    flexWrap: 'wrap',
    display: 'flex',
    alignItems: 'flex-end',
  },
  childMarginBig: {
    '& >:nth-child(n)': {
      my: 1,
      mr: { xs: 3, lg: 4, xl: 4 },
    },
  },
} as const;

type JstSubmissionInputsProps = {
  inputState: JstSubmission;
  setInputState: (value: JstSubmission) => void;
  onSaveClick?: () => void;
};

const JstSubmissionInputsGroup: FC<JstSubmissionInputsProps> = ({ onSaveClick, inputState, setInputState }) => {
  const onInputChange = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    setInputState({ ...inputState, [event.target.name]: event.target.value });
  };
  const onNumberChange = (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
    setInputState({ ...inputState, [event.target.name]: event.target.value });
  };

  return (
    <>
      <Box sx={{ ...styles.childMarginBig, ...styles.spacingContainer }}>
        <Box sx={{ ...styles.spacingContainer }}>
          <Box mr={2}>
            <LabelWrapper label={'Create Simulation File'}>
              <CustomInput
                errorText={'Please enter valid text'}
                required
                maxLength={30}
                onChange={onInputChange}
                value={inputState.simulationFile}
                name={'simulationFile'}
                placeholder={'Enter name'}
              />
            </LabelWrapper>
          </Box>
          <Box sx={{ ...styles.spacingContainer }}>
            <SquaredIconButton onClick={onSaveClick} variant={'contained'} color={'success'}>
              <SaveIcon />
            </SquaredIconButton>
          </Box>
        </Box>
        <CustomButton type={'submit'} variant={'contained'} color={'success'}>
          <Typography color={'info.contrastText'} variant={'subtitle2'}>
            Submit
          </Typography>
        </CustomButton>
      </Box>
    </>
  );
};

export default memo(JstSubmissionInputsGroup);
